import { useQuery } from "@apollo/client";
import { GET_ENTITY_ATTRIBUTES } from "../../api/get-entity-attributes";
import { GetEntityAttributesQueryVariables } from "gql/graphql";

export function useEntityAttributes(
  variables: GetEntityAttributesQueryVariables,
) {
  return useQuery(GET_ENTITY_ATTRIBUTES, {
    variables,
  });
}
